<template>
  <v-app :theme="isDark ? 'dark' : 'light'">
    <!-- Sidebar contraíble -->
    <v-navigation-drawer
      v-if="usuario"
      v-model="drawer"
      :permanent="isDesktop"
      :temporary="!isDesktop"
      :mini-variant="sidebarMini"
      app
      clipped
      :color="isDark ? '#1a1a1e' : '#2d3748'"
      dark
      width="220"
      mini-variant-width="48"
      class="sidebar sidebar-below-header">
      <div class="sidebar-content">
        <!-- Usuario logueado -->
        <div class="sidebar-user">
          <v-avatar size="40" color="rgba(255,255,255,0.2)">
            <span class="white--text text-body-2 font-weight-bold">{{ usuarioIniciales }}</span>
          </v-avatar>
          <div class="sidebar-user__name">{{ usuario.name }} {{ usuario.surname }}</div>
        </div>
        <v-list dense nav class="sidebar-nav-list">
          <v-list-item to="/inicio" link exact active-class="primary--text">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Inicio</v-list-item-title>
        </v-list-item>
        <v-list-item to="/disponibilidad" link active-class="primary--text">
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Disponibilidad</v-list-item-title>
        </v-list-item>
        <v-list-item to="/colaboradores" link active-class="primary--text">
          <v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Colaboradores</v-list-item-title>
        </v-list-item>
        <v-divider class="my-2" />
        <v-list-item href="https://grupoairteams.sharepoint.com/sites/GA-GestindePersonas/Lists/Solicitud%20de%20Mejoras%20%20Casa%20Matriz/Tablero.aspx?env=WebViewList" target="_blank" rel="noopener">
          <v-list-item-icon>
            <v-icon>mdi-clipboard-list</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Ver solicitudes</v-list-item-title>
        </v-list-item>
        <v-list-item href="https://grupoairteams.sharepoint.com/sites/GA-GestindePersonas/_layouts/15/listforms.aspx?cid=ZWQ3M2ZhMDEtNzNlOS00NzI1LTliNjItOWZkNGQ2NGI2ZDI4&nav=MTI1NTk4OTMtZDRmMi00OTQ2LTgxMGQtMzg3ZDQ0N2E0NTE4" target="_blank" rel="noopener">
          <v-list-item-icon>
            <v-icon>mdi-file-document-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Crear solicitud</v-list-item-title>
        </v-list-item>
        </v-list>
      </div>
      <v-divider />
      <!-- Cerrar sesión -->
      <div class="sidebar-footer">
        <v-list dense>
          <v-list-item @click="cerrarSesion" class="sidebar-logout">
            <v-list-item-icon>
              <v-icon color="red">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="red--text">Cerrar sesión</v-list-item-title>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>

    <!-- Barra superior: ancho completo, por encima del sidebar -->
    <v-app-bar
      v-if="usuario"
      app
      clipped-left
      :color="isDark ? '#0e0e10' : '#1f2937'"
      dark
      flat
      elevate-on-scroll
      height="64"
      class="px-6"
    >
      <v-app-bar-nav-icon v-if="!isDesktop" @click="drawer = !drawer" />
      <v-app-bar-nav-icon v-else @click="toggleSidebarMini" :title="sidebarMini ? 'Expandir menú' : 'Contraer menú'">
        <v-icon>mdi-{{ sidebarMini ? 'menu' : 'backburger' }}</v-icon>
      </v-app-bar-nav-icon>
      <!-- Logo -->
      <router-link to="/inicio">
        <v-img
          alt="Logo Empresa"
          class="shrink"
          contain
          :src="isDark ? darkLogo : lightLogo"
          width="140"
          style="cursor: pointer"
        />
      </router-link>

      <v-spacer />

      <!-- Modo oscuro / claro -->
      <v-btn icon @click="toggleTheme" :title="isDark ? 'Modo claro' : 'Modo oscuro'">
        <v-img
          :src="isDark ? isotipoClaro : isotipoOscuro"
          alt="Tema"
          contain
          width="28"
          height="28"
        />
      </v-btn>
    </v-app-bar>

    <!-- Banner Experticia para usuarios no logueados (login, etc.) -->
    <v-app-bar
      v-else
      app
      :color="isDark ? '#0e0e10' : '#1f2937'"
      dark
      flat
      height="64"
      class="px-6 guest-bar"
    >
      <v-img
        alt="Experticia"
        class="shrink"
        contain
        :src="isDark ? darkLogo : lightLogo"
        width="140"
        height="40"
      />
      <v-spacer />
      <v-btn icon @click="toggleTheme" :title="isDark ? 'Modo claro' : 'Modo oscuro'">
        <v-img
          :src="isDark ? isotipoClaro : isotipoOscuro"
          alt="Tema"
          contain
          width="28"
          height="28"
        />
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <!-- Snackbar global (notificaciones) -->
    <v-snackbar v-model="notify.show" :color="notify.color" timeout="3500" top right>
      <v-icon left v-if="notify.icon">{{ notify.icon }}</v-icon>
      {{ notify.text }}
      <v-btn text @click="notify.show = false">Cerrar</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { eventBus } from "@/helpers/eventBus";

export default {
  name: "App",
  data() {
    return {
      drawer: false,
      sidebarMini: localStorage.getItem("sidebarMini") === "true",
      isDark: localStorage.getItem("theme") === "dark",
      lightLogo: require("@/assets/Logo Experticia Blanco Celeste.png"),
      darkLogo: require("@/assets/Logo Experticia Blanco Celeste.png"),
      isotipoClaro: require("@/assets/Isotipo Blanco.png"),
      isotipoOscuro: require("@/assets/Isotipo Gris.png"),
      usuario: JSON.parse(
        sessionStorage.getItem("usuario") || localStorage.getItem("usuario") || "null"
      ),
      notify: {
        show: false,
        text: "",
        color: "info",
        icon: "",
      },
    };
  },
  computed: {
    isDesktop() {
      return this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.mdAndUp;
    },
    esAdmin() {
      const rol = (this.usuario && this.usuario.rol) ? String(this.usuario.rol).trim().toLowerCase() : "";
      return rol === "admin" || rol === "administrador";
    },
    usuarioIniciales() {
      const u = this.usuario;
      if (!u) return "?";
      const n = (u.name || "").trim();
      const s = (u.surname || "").trim();
      const a = n ? n[0].toUpperCase() : "";
      const b = s ? s[0].toUpperCase() : n.length > 1 ? n[1].toUpperCase() : "";
      return (a + b) || "?";
    },
  },
  created() {
    eventBus.$on("notify", ({ text, color, icon }) => {
      this.notify.text = text || "";
      this.notify.color = color || "info";
      this.notify.icon = icon || "";
      this.notify.show = true;
    });
    eventBus.$on("usuario-logeado", (u) => {
      this.usuario = u;
    });
  },
  mounted() {
    this.$vuetify.theme.dark = this.isDark;
  },
  watch: {
    isDark(val) {
      this.$vuetify.theme.dark = val;
    },
  },
  methods: {
    toggleTheme() {
      this.isDark = !this.isDark;
      this.$vuetify.theme.dark = this.isDark;
      localStorage.setItem("theme", this.isDark ? "dark" : "light");
    },
    toggleSidebarMini() {
      this.sidebarMini = !this.sidebarMini;
      localStorage.setItem("sidebarMini", this.sidebarMini ? "true" : "false");
    },
    cerrarSesion() {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("usuario");
      localStorage.removeItem("usuario");
      this.usuario = null;
      this.$router.push("/");
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap");

body {
  font-family: "Poppins", sans-serif;
  margin: 0;
}

.v-main {
  min-height: 100vh;
  transition: background-color 0.3s ease;
}

.theme--light .v-main {
  background: linear-gradient(135deg, #e8eef5, #d1dae8);
  color: #1f2937;
}

.theme--dark .v-main {
  background: linear-gradient(135deg, #7484ab, #080a0e);
  color: #e0e0e0;
}

.v-btn {
  transition: all 0.3s ease;
  font-weight: 500;
}

.v-btn:hover {
  transform: scale(1.04);
  opacity: 0.95;
}

.theme--dark.v-application {
  background-color: transparent !important;
  color: #e0e0e0 !important;
}

.theme--dark .v-card,
.theme--dark .v-container,
.theme--dark .v-list {
  color: #ffffff !important;
}

/* Tabla disponibilidad en modo oscuro */
.theme--dark .availability-table th,
.theme--dark .availability-table td {
  border-color: #424242;
}

.theme--dark .availability-table thead th {
  background: #2d2d2d !important;
  color: #e0e0e0 !important;
}

.theme--dark .availability-table tbody tr:hover {
  background: #383838 !important;
}

.theme--dark .cell-day {
  color: #e0e0e0;
}

.theme--dark .legend {
  background: #2d2d2d;
  border-top-color: #424242;
}

.theme--dark .availability-card {
  background: #1e1e1e;
}

.v-list {
  font-size: 0.85rem;
}

.v-list-item {
  min-height: 32px !important;
}

.v-list-item-title {
  font-size: 0.85rem;
}

.sidebar .v-list-item--active {
  border-right: 3px solid currentColor;
}

/* Sidebar: usuario en el recuadro superior (debajo del header) */
.sidebar-below-header .sidebar-user {
  padding: 12px 16px;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
/* Mini-variant: avatar centrado y más compacto */
.sidebar.v-navigation-drawer--mini-variant .sidebar-user {
  flex-direction: column;
  padding: 12px 8px;
  padding-top: 16px;
  justify-content: flex-start;
}
.sidebar.v-navigation-drawer--mini-variant .sidebar-user .v-avatar {
  margin: 0 auto;
  transform: translateX(-4px);
}
.sidebar.v-navigation-drawer--mini-variant .sidebar-user__name {
  display: none;
}
.sidebar-user__name {
  font-size: 0.9rem;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.sidebar-nav-list {
  padding-top: 8px;
  flex: 1;
}
/* Cerrar sesión fijo abajo del sidebar */
.sidebar-footer {
  flex-shrink: 0;
  padding: 8px 0;
}
.sidebar-logout {
  cursor: pointer;
}
.sidebar >>> .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
